import type { Page, UserDataForActivate } from "@/types";
import {useNavigate, useLocation, useParams} from "react-router-dom";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import {
  activateUser,
  createUser,
  initialValuesForActivate,
  updateUser,
} from "../../reducers/authentications/authenticationsSlice"
import { useDispatch, useSelector } from 'react-redux'
import {AppDispatch, RootState} from "../../store";
import Layout from '../layout/layout';


const LandingPage: Page = () => {
  const {
    activateToken
  } = useParams();
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [record, setRecord] = useState<UserDataForActivate>(initialValuesForActivate)
  const [submitted, setSubmitted] = useState(false);
  const [validate, setValidate] = useState(false)
  const activateUserStatus = useSelector((state: RootState) => state.authentications.activateUserStatus);
  const message = useSelector((state: RootState) => state.authentications.message);
  const toast = useRef<Toast | null>(null);
  const user = useSelector((state: RootState) => state.authentications.user);
  const tokenValid = useSelector((state: RootState) => state.authentications.tokenValid);


  const location = useLocation();
  const fromManagement = location.state?.from?.pathname || "/admin";
  const fromVoter = location.state?.from?.pathname || "/voting";
  const fromOrganizer = location.state?.from?.pathname || "/organizer";

  useEffect(() => {
      if (user.token && tokenValid && activateUserStatus === "succeeded"){
        let userRole = user.userRole;
          if (userRole === 'administrator'){
              navigate(fromManagement);
          }
          else if(userRole === 'pageantOrganizer'){
              navigate(fromOrganizer);
          }
          else if(userRole === 'voter'){
              navigate(fromVoter);
          }
      }
    }, [user, activateUserStatus]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
      dispatch(updateUser(null))
    },[])

    const onSubmit = () => {

        setValidate(true);
        let canSubmit = Boolean(
          record.password &&
          record.password ===record.password2 &&
          record.password2
        )
        if(canSubmit){
          setSubmitted(true);
          let record_ = {...record}
          record_["activateCode"] = activateToken
          dispatch(activateUser(record_))
        }

    };

    useEffect(()=>{
      if(submitted){

          if(activateUserStatus === "succeeded"){
            setRecord(initialValuesForActivate)
            setSubmitted(false)
            setValidate(false)
          }else if(activateUserStatus === "failed"){
            toast.current?.show({
                severity: "error",
                summary: "Failed",
                detail: message,
                life: 3000,
            });
            setSubmitted(false)
          }
      }
    }, [activateUserStatus, submitted])

    const onInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        name: "password" | "password2"
    ) => {
        const val = (e.target && e.target.value) || "";
        let _record = { ...record };
        _record[`${name}`] = val;
        setRecord(_record);
    };


    return (
      <Layout>
        <Toast ref={toast} position="center" />
        <div className="px-5 min-h-screen flex justify-content-center align-items-center">
            <div className="border-1 surface-border surface-cards card border-round py-7 px-4 md:px-7 z-1">
                <div className="mb-4">
                    <div className="text-900 text-xl font-bold mb-2">
                        Activate Account
                    </div>

                </div>
                <div className="flex flex-column">
                    <span className="p-input-icon-left w-full mb-4">
                        <i className="pi pi-lock z-2"></i>
                        <Password
                            id="password"
                            // type="password"
                            value={record.password}
                            className="w-full"
                            inputClassName="w-full"
                            placeholder="Password"
                            toggleMask
                            feedback={false}
                            inputStyle={{ paddingLeft: "2.5rem" }}
                            onChange={(e)=>onInputChange(e,"password")}
                        />
                        {validate && !record.password && (
                            <small className="p-invalid p-error w-full">
                                Password is required.
                            </small>
                        )}
                    </span>
                    <span className="p-input-icon-left w-full mb-4">
                        <i className="pi pi-lock z-2"></i>
                        <Password
                            id="password2"
                            // type="password2"
                            value={record.password2}
                            className="w-full"
                            inputClassName="w-full"
                            placeholder="Password"
                            toggleMask
                            feedback={false}
                            inputStyle={{ paddingLeft: "2.5rem" }}
                            onChange={(e)=>onInputChange(e,"password2")}
                        />
                        <div>
                            {validate && !record.password2 && (
                                <small className="p-invalid p-error w-full">
                                    Confirm is required.
                                </small>
                            )}
                            {validate && record.password2 && record.password !==record.password2 && (
                                <small className="p-invalid p-error w-full">
                                    Password Does Not Match.
                                </small>
                            )}
                        </div>
                    </span>
                    <div className="flex flex-column align-items-center">
                      <Button
                          className="beautiful-discord-button w-5 flex flex-column align-items-center mt-2"
                          label="Activate"
                          onClick={() => onSubmit()}
                      >
                      </Button>
                    </div>
                </div>
            </div>
        </div>
      </Layout>
    );
};

export default LandingPage;
